import { not, and } from 'ramda'

export function sideBar() {
  return ({
    init() {
      const trigger = $('.header__input-trigger_menu')
      const trigger_lang = $('.header__input-trigger_language-dropdown')
      const cover = $('.header__cover')
      const logo = $('.header__logo')

      function onScroll() {        
        if (window.innerWidth > 576) return;
        const scrollTop = $(this).scrollTop();        
        const coord = {
          scroll: { marginTop: `-${scrollTop}px` },
          static: { marginTop: `0` }
        }
        scrollTop > 0 ? logo.css(coord.scroll) : logo.css(coord.static)
      }      

      function onTriggerChange() {
        trigger_lang.prop('checked', false)
        cover.fadeToggle('200')
      }

      function closeSidebar() {
        trigger.prop('checked', false)
        trigger_lang.prop('checked', false)
        cover.fadeOut('200')
      }

      function onResize() {
        if (and(
          this.innerWidth > 1100,
          trigger.is(':checked')
        )) closeSidebar()
      }

      
      if ($('.header_home').length) {
        $(window).on('scroll', onScroll)        
      }
      trigger.on('change', onTriggerChange)
      cover.on('click', closeSidebar)
      $(window).on('resize', onResize)
        .on('click', function(e) {
          if (e.target.className === 'header__language-list') {
            e.stopPropagation()
            e.preventDefault()
          }
          if (not(
            document.querySelector('.header__language')
              .contains(e.target))
          ) trigger_lang.prop('checked', false)
        })
    }
  })
}